<template>
<v-container grid-list-xl fluid>
    <v-layout row wrap>
        <v-flex lg12>
            <v-card>
                <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
                <v-data-table :headers="headers" :items="items" :options.sync="pagination" :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true" :loading="loading" :mobile-breakpoint="100">
                    <template v-slot:item="{ item }">
                        <tr>
                            <td>{{ item.created_at | display_date_tz }}</td>
                            <td>{{ item.user_name }}</td>
                            <td>{{ item.function_name }}</td>
                            <td>{{ item.content }}</td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "@/configs";
import Filtering from "@/components/Filtering";
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering
    },
    data() {
        return {
            viewName: "system_logs",
            dialogItem: false,
            headers: [{
                    text: "Ngày",
                    value: "created_at",
                    filterable: true,
                    width: "150px",
                    dataType: configs.DATA_TYPE["Date"]
                },
                {
                    text: "Tài khoản",
                    value: "user_name",
                    filterable: true,
                    quickSearch: true,
                    width: "150px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Chức năng",
                    value: "function_name",
                    filterable: true,
                    quickSearch: true,
                    width: "200px",
                    dataType: configs.DATA_TYPE["String"]
                },
                {
                    text: "Nội dung",
                    value: "content",
                    filterable: true,
                    quickSearch: true,
                    dataType: configs.DATA_TYPE["String"]
                }
            ],
            pagination: _.cloneDeep(configs.PAGINATION),
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            filterConditions: [],
            quickFilterConditions: [],
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
    },
    computed: {
        ...mapState({
            items: state => state.system_logs.all.data,
            total_rows: state => state.system_logs.all.total,
            loading: state => state.system_logs.loading,
            currentItem: (state) => state.system_logs.selected
        })
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: [...this.filterConditions],
                quickFilter: this.quickFilterConditions
            };
            this.$store.dispatch("system_logs/getList", param);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        }
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    }
};
</script>
